import React, { useEffect } from 'react';
import Select from '../ui/Select';
import { useInterventionPoint } from '../../contexts/InterventionPointContext';
import { API_BASE_URL } from '../../config';
import baseFetchWithAuth from '../../utils/fetchWithAuth';

const InterventionPointSelectionHeader = ({ jail }) => {
  const {
    projets,
    setProjets,
    selectedProjet,
    setSelectedProjet,
    searchQuery,
    setSearchQuery,
    interventionPoints,
    setProjectsLoaded
  } = useInterventionPoint();

  useEffect(() => {
    const loadProjets = async () => {
      try {
        const response = await baseFetchWithAuth(`${API_BASE_URL}/api/dwh/one_mag/projects`);
        if (Array.isArray(response)) {
            const formattedProjets = response.map(p => ({
                value: p.projectId,
                label: p.projectName
            }));
            setProjets(formattedProjets);
        }
      } catch (error) {
        console.error("Error fetching projects:", error);
      } finally {
        setProjectsLoaded(true);
      }
    };
    loadProjets();
  }, [setProjets, setProjectsLoaded]);

  return (
    <div className="mb-4 relative z-10">
      <div className="border border-gray-200 dark:border-gray-700 rounded-lg p-3 bg-white dark:bg-gray-800">
        <div className={`grid grid-cols-1 md:grid-cols-${jail ? '1' : '2'} gap-3`}>

          {!jail && (
            <div className="md:col-span-1">
              <label className="block text-xs font-medium text-gray-700 dark:text-gray-300 text-left mb-1.5">Projet</label>
              <Select
                isClearable
                isSearchable
                value={selectedProjet}
                onChange={setSelectedProjet}
                options={projets}
                placeholder="Sélectionnez un projet..."
                classNamePrefix="react-select"
                menuPortalTarget={document.body}
              />
            </div>
          )}

          <div className="md:col-span-1">
            <label className="block text-xs font-medium text-gray-700 dark:text-gray-300 text-left mb-1.5">
              Recherche {interventionPoints.length > 0 && `(${interventionPoints.length} points chargés)`}
            </label>
            <div className="relative">
              <input
                type="text"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                disabled={!selectedProjet}
                placeholder="Nom, enseigne ou code SAP..."
                className="w-full px-3 py-2 pr-9 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm dark:bg-gray-700 dark:text-white"
              />
              {searchQuery && (
                <button
                  type="button"
                  onClick={() => setSearchQuery('')}
                  title="Effacer la recherche"
                  className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600 dark:hover:text-gray-200"
                >
                  <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InterventionPointSelectionHeader;
